import React, { useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import './scolarite.scss';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getDashboardFactures } from '../factures/facture.reducer';
import { Col, Row } from 'antd';

type SuiviScolariteProps = {
  scolariteId: string;
};

const SuiviScolarite: React.FC<SuiviScolariteProps> = ({ scolariteId }) => {
  const dispatch = useAppDispatch();
  const { dashBoardEntities: factures, errorMessage, loading } = useAppSelector(state => state.facture);
  const factureData = useAppSelector(state => state.facture.dashBoardEntities);

  useEffect(() => {
    dispatch(getDashboardFactures(scolariteId));
  }, [dispatch]);

  const chartData1 = {
    labels: ['Collecté', 'En Attente', 'Espèce'],
    datasets: [
      {
        data: [factureData.collectedByKorischool, factureData.totalRemaining, factureData.collectedByEspece],
        backgroundColor: ['rgba(75,192,192,1.5)', '#bf616a', '#ffcb75'],
        hoverBackgroundColor: ['rgba(75,192,192,1.5)', '#F08080', 'rgb(255,203,117,0.7)'],
      },
    ],
  };
  const chartData2 = {
    labels: ['Total Payées', 'Total En Attente'],
    datasets: [
      {
        data: [factureData.totalFacturesPayees, factureData.totalFacturesEnAttentes],
        backgroundColor: ['#17a2b8', '#FF6384'],
        hoverBackgroundColor: ['#17a2b8', '#FF6384'],
      },
    ],
  };
  const chartData3 = {
    labels: ['Encaissement Wave', 'Encaissement OMoney'],
    datasets: [
      {
        data: [factureData.totalWavePaye, factureData.totalOmPaye],
        backgroundColor: ['#1cc8ff', '#F4810D'],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
    cutout: '60%',
  };
  const isChartData3Empty = chartData3.datasets[0].data.every(value => value === 0);

  return (
    <div className="suivi-scolarite-container">
      <h2>SUIVI SCOLARITE</h2>
      <div className="chart-container">
        {loading && <p>Loading...</p>}
        {errorMessage && <p>Error: {errorMessage}</p>}
        {!loading && !errorMessage && (
          <>
            <div className="chart-title">Vue d&apos;ensemble des paiements</div>
            <Row justify="space-around">
              <Col xs={{ span: 14 }} lg={{ span: 7 }}>
                <Doughnut data={chartData1} options={options} />
                <h6>Montants Collectés</h6>
              </Col>
              {isChartData3Empty ? null : (
                <Col xs={{ span: 14 }} lg={{ span: 7 }}>
                  <Doughnut data={chartData3} options={options} />
                  <p>Répartition Wave/OMoney</p>
                </Col>
              )}
              <Col xs={{ span: 14 }} lg={{ span: 7 }}>
                <Doughnut data={chartData2} options={options} style={{ height: '400px' }} />
                <h6>Nombre de factures</h6>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default SuiviScolarite;
